import { IAppState } from '../context'
import { key } from '../reducers/appSetupReducer'

export const selectAppSetup = (appState: IAppState) => appState[key]
